import React from 'react';
import { createPortal } from 'react-dom';

export const PageTitle = ({ children }: React.PropsWithChildren<any>) => {
  return createPortal(children, document.getElementById('header-portal')!);
};
